import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { UnscrambleForm } from "../components/UnscrambleForm";
import { WordResults } from "../components/WordResults";
import { WuBreadcrumb } from "../components/WuBreadcrumb";
import { WuExplainer } from "../components/WuExplainer";
import { useUnscramble } from "../hooks/use-unscramble";
import { getCurated } from "../lib/curated";
import { normalizeLetters } from "../lib/unscramble";

export function LettersPage({ letters }: { letters: string }) {
  const { data } = useUnscramble(letters);
  const normalized = data?.letters ?? normalizeLetters(letters).slice(0, 12);
  const upper = normalized.toUpperCase();

  return (
    <div className="pct-page relative min-h-screen">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-96 pct-glow" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <WuBreadcrumb current={upper} />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.wu_letters_h1({ letters: upper })}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.wu_letters_intro({ letters: upper })}
          </p>
        </header>

        <UnscrambleForm initial={normalized} />

        <div className="mt-8">
          {data ? (
            <WordResults
              letters={data.letters}
              words={data.words}
              anagrams={data.anagrams}
              total={data.total}
            />
          ) : (
            <p className="text-muted-foreground">{m.wu_loading()}</p>
          )}
        </div>

        <WuExplainer
          // Curated words get their own editorial copy (anagram-family story +
          // word-specific FAQs); non-curated pages are noindexed by the route,
          // so their fallback to hub copy is harmless.
          howTo={getCurated(normalized)?.howTo() ?? m.wu_hub_howto()}
          faqs={[
            { q: m.wu_hub_faq1_q(), a: m.wu_hub_faq1_a() },
            { q: m.wu_hub_faq2_q(), a: m.wu_hub_faq2_a() },
            ...(getCurated(normalized)?.faqs.map((f) => ({
              q: f.q(),
              a: f.a(),
            })) ?? []),
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
